import request from '../../utils/request'
import { getOrderStatusLabel } from '../../utils/enums'

const state = {
  orders: []
}

const getters = {
  allOrders: state => state.orders,
  getOrderStatusLabel: () => (status) => getOrderStatusLabel(status)
}

const mutations = {
  SET_ORDERS(state, orders) {
    state.orders = orders
  },
  ADD_ORDER(state, order) {
    state.orders.push(order)
  },
  DELETE_ORDER(state, orderId) {
    state.orders = state.orders.filter(order => order.id !== orderId)
  },
  UPDATE_ORDER_STATUS(state, { orderId, status }) {
    const orderIndex = state.orders.findIndex(order => order.id === orderId || order.orderId === orderId)
    if (orderIndex !== -1) {
      state.orders[orderIndex].status = status
    }
  }
}

const actions = {
  async fetchAllOrders({ commit }, { page = 1, size = 10, filters = {} } = {}) {
    const requestData = { page, size }

    if (filters.customerName) requestData.customerName = filters.customerName
    if (filters.customerType !== '' && filters.customerType !== null && filters.customerType !== undefined) {
      requestData.customerType = Number(filters.customerType)
    }
    if (filters.orderStatus !== '' && filters.orderStatus !== null && filters.orderStatus !== undefined) {
      requestData.orderStatus = Number(filters.orderStatus)
    }
    if (filters.paymentType !== '' && filters.paymentType !== null && filters.paymentType !== undefined) {
      requestData.paymentType = Number(filters.paymentType)
    }
    if (filters.createdBy) requestData.createdBy = filters.createdBy

    const pageResult = await request.post('/api/order/list', requestData)
    const apiOrders = (pageResult && pageResult.records) || []

    const mappedOrders = apiOrders.map(order => ({
      id: order.id,
      orderId: order.orderId,
      customerName: order.customerName,
      createdBy: order.createdBy || '系统',
      type: order.customerType,
      productId: order.productId,
      productName: order.productName,
      amount: order.totalAmount,
      orderQuantity: order.orderQuantity,
      paymentType: order.paymentType,
      depositAmount: order.depositAmount,
      canCancel: order.canCancel,
      orderDate: order.createdTime ? String(order.createdTime).replace('T', ' ').split(' ')[0] : '',
      remark: order.orderRemark,
      status: order.orderStatus,
      createdAt: order.createdTime ? new Date(order.createdTime) : null,
      createdTime: order.createdTime
    }))

    commit('SET_ORDERS', mappedOrders)
    return {
      records: mappedOrders,
      total: pageResult && pageResult.total,
      current: pageResult && pageResult.current,
      size: pageResult && pageResult.size,
      pages: pageResult && pageResult.pages
    }
  },

  async createOrder({ commit }, orderData) {
    const order = await request.post('/api/order', orderData)
    commit('ADD_ORDER', order)
    return order
  },

  async deleteOrder({ commit }, orderId) {
    await request.delete(`/api/order/${orderId}`)
    commit('DELETE_ORDER', orderId)
  },

  async updateOrderStatus({ commit }, { orderId, orderStatus }) {
    const order = await request.put(`/api/order?orderStatus=${orderStatus}&orderId=${orderId}`)
    commit('UPDATE_ORDER_STATUS', { orderId, status: orderStatus })
    return order
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
